import { store } from "../store";
import {
  createNotificationSap,
  deleteNotificationSap,
  updateNotificationSap,
} from "../store/actions/NotificationSapActions";

export const create = async (productionOrderSapUuid, data) => {
  const result = await store.dispatch(
    createNotificationSap(productionOrderSapUuid, data),
  );
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const remove = async (notificationSapUuid) => {
  const result = await store.dispatch(
    deleteNotificationSap(notificationSapUuid),
  );
  if (result?.payload) {
    return result.payload;
  }
  return null;
};

export const update = async (notificationSapUuid, data) => {
  const result = await store.dispatch(
    updateNotificationSap(notificationSapUuid, data),
  );
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
